import { UntypedFormArray, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit, Inject } from '@angular/core';
import { Warranty } from '../../models/warranty.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Tenant } from 'src/app/models/tenant.model';
import { ErrorResponse } from '../../models/error.model';
import { GuarantiesService } from '../../services/guaranties.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-rescoring-dialog',
    templateUrl: './rescoring-dialog.component.html',
    styleUrls: ['./rescoring-dialog.component.scss']
})
export class RescoringDialogComponent implements OnInit {

    rescoringFG = new UntypedFormArray([]);

    get tenantFormGroups() {
        return this.rescoringFG.controls as UntypedFormGroup[];
    }

    constructor(
        private guarantiesService: GuarantiesService,
        private utilsService: UtilsService,
        private dialogRef: MatDialogRef<RescoringDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public warranty: Warranty,
    ) { }

    ngOnInit(): void {
        this.fillFormWithTenants(this.warranty.inquilinos);
    }

    cerrarDialogo(warranty?: Warranty) {
      this.dialogRef.close(warranty);
    }

    fillFormWithTenants(tenants: Tenant[]) {
        for (const tenant of tenants) {
            this.rescoringFG.push(new UntypedFormGroup({
                idInquilino: new UntypedFormControl(tenant.id),
                dni: new UntypedFormControl(tenant.personaFisica?.dni, tenant.tipoPersona === 'FISICA' ? [Validators.required, Validators.minLength(8), Validators.maxLength(8), this.utilsService.numberFormValidator] : []),
                sexo: new UntypedFormControl(tenant.personaFisica?.sexo, tenant.tipoPersona === 'FISICA' ? [Validators.required] : []),
                cuit: new UntypedFormControl(tenant.personaJuridica?.cuit, tenant.tipoPersona === 'JURIDICA' ? [Validators.required, Validators.minLength(11), Validators.maxLength(11), this.utilsService.numberFormValidator] : []),
            }));
        }
    }

    submit() {
        this.rescoringFG.markAllAsTouched();
        if (!this.rescoringFG.valid) return;
        this.guarantiesService.rescoring(this.warranty.id, this.rescoringFG.getRawValue()).subscribe(warranty => {
            this.cerrarDialogo(warranty);
        }, (error: ErrorResponse) => this.utilsService.alert('Error al realizar scoring', error.error?.descripcion));
    }

}
